import { render, staticRenderFns } from "./SearchCouriers.vue?vue&type=template&id=1830d540&scoped=true&"
import script from "./SearchCouriers.vue?vue&type=script&lang=js&"
export * from "./SearchCouriers.vue?vue&type=script&lang=js&"
import style0 from "./SearchCouriers.vue?vue&type=style&index=0&id=1830d540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830d540",
  null
  
)

export default component.exports